export const API_BASE_URL = 'https://api.ascaa.lamoom.com';
export const API_URL = API_BASE_URL;
export const AUTH_ENDPOINTS = {
    LOGIN: 'https://ascaa-consultancy.auth.us-east-2.amazoncognito.com/login',
    CLIENT_ID: 'mlfb5b0lguku1c3t862h9bcu9',
    REDIRECT_URI: `${window.location.origin}/login/callback`,
    getCognitoLoginUrl: () => {
        const params = new URLSearchParams({
            client_id: AUTH_ENDPOINTS.CLIENT_ID,
            response_type: 'code',
            redirect_uri: AUTH_ENDPOINTS.REDIRECT_URI,
            scope: 'openid email profile'
        });
        return `${AUTH_ENDPOINTS.LOGIN}?${params.toString()}`;
    }
}; 